// Mantine CSS
import '@mantine/core/styles.css';
import { MantineProvider } from '@mantine/core';

// Base CSS
import './assets/css/app.css';
import './assets/css/fonts.css';
import './assets/css/mobile-optimizations.css';

import Footer from './components/footer';

// Pages
import Landing from './views/Landing';

import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

function App() {
    return (
        <MantineProvider>
            <Router>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100vh',
                    }}>
                    <main
                        role="main"
                        style={{
                            flex: 1,
                            display: 'flex',
                            flexDirection: 'column',
                        }}>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            {/* Legacy pages folded into the one-page site */}
                            <Route path="/about" element={<Navigate to="/" replace />} />
                            <Route path="/contact" element={<Navigate to="/" replace />} />
                        </Routes>
                    </main>
                    <Footer />
                </div>
            </Router>
        </MantineProvider>
    );
}

export default App;
